import { ednLang } from "./ednLang"

//Mixin des regex et des messages invalides
export const ednRegex = {
  props: {
    pattern: {
      type: RegExp
    }
  },
  data() {
    return {
      count:0,
      sInvalidMsg: "",
      oInvalidMsg:{
        'edn-phone':'$vuetify.invalidMsg.phone',
        'edn-mail':'$vuetify.invalidMsg.email',
        'edn-url':'$vuetify.invalidMsg.url',
        'edn-image':'$vuetify.invalidMsg.image',
        'edn-cat-arbo':'$vuetify.invalidMsg.arbo',
        'edn-field':'$vuetify.invalidMsg.field',
        'edn-num':'$vuetify.invalidMsg.num',
      },
    }
  },
  mixins: [ednLang],
  created () {
    // On récupère la res par défaut pour le message invalide en fonction du type
    this.sInvalidMsg = this.oInvalidMsg[this.$options.name] != undefined ? this.$vuetify.lang.t(this.oInvalidMsg[this.$options.name]) : '';
  },
  mounted() {
    this.fillRules();
  },
  watch: {
    /**
     * Met à jour le message invalide si la langue change
     */
    '$vuetify.lang.current': function () {
      this.sInvalidMsg = this.oInvalidMsg[this.$options.name] != undefined ? this.$vuetify.lang.t(this.oInvalidMsg[this.$options.name]) : '';
    },
    /* eslint-disable no-unused-vars */
    '$attrs.rdonly':function(val){
      this.fillRules();
    }
    /* eslint-disable no-unused-vars */
  },
  computed: {
    /**
    * Récupère le message invalide par l'intermediaire d'une locale ou de l'attribut renseigné
    */
    invalidMsg:{
      get:function(){
        return this.$attrs.invalidMsg || this.$attrs['invalid-msg']  || this.sInvalidMsg;
      },
      set : function(val){
        this.sInvalidMsg = val;
      }
    },
    /** Renvoie les règles du composants en fonction de la pattern (regex) */
    oRules (){
      return {
        'edn-field': value => {
          return this.pattern.test(value) || this.invalidMsg;
        },
        'edn-social': () => {
          return this.pattern.test(this.getPrefixedUrl) || this.invalidMsg;
        },
      }
    },
  },
  /**
   * Le composant est-il conforme aux règles définies sur la prop Regex ?
   */
  methods: {
    isReady(e) {
      this.readyToConvert = !e
    },
    /**
     * Permet d'enregistrer les règles de validation du champs
     * Si on renseigne un prefixe on vérifie le résultat de la concaténation préfixe + valeur sinon la valeur.
     */
    fillRules(){
      this.rules = [];
      let requiredRules = this.isRequired()[0];
      let invalidRules = !this.isUrlPrefixed ? this.oRules['edn-field'] : this.oRules['edn-social'];
      if(requiredRules && requiredRules.length > 0 && !this.$attrs.rdonly) {
        this.rules.push(requiredRules);
      }
      if((!this.$attrs.rules || this.$attrs.rules.length < 0 || this.isUrlPrefixed) && this.pattern) {
        this.rules.push(invalidRules);
      }else if(this.$attrs.rules){
        this.rules = this.$attrs.rules;
      }
    }
  },
}
